import { useQuery } from "@tanstack/react-query";
import {
  QuestionsConfigControllerGetQuestionConfigs200Response,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_QUESTIONS } from "../domain";

import { Error } from "@helpers";
import { questionsConfigApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";


const allowedRoles = [UserRole.Owner, UserRole.Manager];

type GetQuestionConfigsParams = {
  search?: string;
  orderBy?: string;
  orderDirection?: string;
  pageNumber: number;
  pageSize?: number;
  formId?: string;
  filter?: {
    query?: string;
  };
};

const fetchQuestionsConfig = async (
  params: GetQuestionConfigsParams,
): Promise<QuestionsConfigControllerGetQuestionConfigs200Response | undefined> => {
  try {
    const response =
      await questionsConfigApi.questionsConfigControllerGetQuestionConfigs(
        params.filter?.query,
        params.search,
        params.orderBy,
        params.orderDirection,
        params.pageNumber,
        params.pageSize,
      );

    const data = response.data;

    if (response.status === 200 && data) {
      return data;
    }
  } catch (error) {
    Error(error);
  }
};

export const useGetQuestionConfigs = (
  user: UserProfileDto | null,
  params: GetQuestionConfigsParams,
): {
  questionsConfig?: QuestionsConfigControllerGetQuestionConfigs200Response;
  questionsConfigEnabled: boolean;
  isLoadingQuestionsConfig: boolean;
  isFetchingQuestionsConfig: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isLoading, isFetching, data } = useQuery({
    queryKey: [DOMAIN_QUESTIONS, params],
    queryFn: () => fetchQuestionsConfig(params),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    questionsConfig: data,
    questionsConfigEnabled: enabled,
    isLoadingQuestionsConfig: isLoading,
    isFetchingQuestionsConfig: isFetching,
  };
};
